import type { PropsWithChildren } from 'react'
import React, { useMemo, useState } from 'react'
import { useLocation } from 'react-router'

import MenuToggle from '@/assets/menuToggle.png'
import MenuToggle_Light from '@/assets/menuToggle_light.png'
import PageFooter from '@/components/page-footer'
import PageHeader from '@/components/page-header'
import { useLocalStorage } from '@/context/localstorage-context.js'
import { usePageTracking } from '@/hooks/use-page-tracking'

import Aside from '../Aside/Aside'

import { Container, Main, Part1, BtnToggle, MBody } from './Layout.module'

const Layout: React.FC<PropsWithChildren> = ({ children, ...rest }) => {
  const [toggled, setToggled] = useState(false)
  const location = useLocation()
  usePageTracking()
  const handleToggleSidebar = (value: boolean) => setToggled(value)
  const isHomepage = useMemo(
    () => location.pathname !== '/',
    [location.pathname],
  )
  const { theme } = useLocalStorage()
  const isdark = useMemo(() => theme === 'dark', [theme])

  return (
    <Container
      className="bg-theme-light dark:bg-theme-dark  md:bg-theme-light-media md:dark:bg-theme-dark-media"
      {...rest}
    >
      <Aside toggled={toggled} handleToggleSidebar={handleToggleSidebar} />
      <Main isHomepage={isHomepage}>
        <Part1 isdark={isdark}>
          <BtnToggle onClick={() => handleToggleSidebar(true)}>
            <img
              src={isdark ? MenuToggle : MenuToggle_Light}
              alt="menuToggle"
              width={40}
            />
          </BtnToggle>
          <PageHeader />
        </Part1>
        <MBody isHomepage={isHomepage}>{children}</MBody>
        {!isHomepage && <PageFooter />}
      </Main>
    </Container>
  )
}

export default Layout
